import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  History,
  PersonAddAltOutlined,
  SearchOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

//Services
import passengerApi from "Services/Passenger";

//Modals
import PassengerAddModal from "Pages/Modals/Passenger/Create";
import PassengerUpdateModal from "Pages/Modals/Passenger/Update";
import PassengerDeleteDialog from "Pages/Modals/Passenger/Delete";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [searchText, setSearchText] = useState("");

  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Modals
  const [addPassenderModal, setAddPassengerModal] = useState(false);
  const [updatePassenderModal, setUpdatePassengerModal] = useState(false);
  const [deletePassengerModal, setdeletePassengerModal] = useState(false);

  const handleOpenAddPassengerModal = () => setAddPassengerModal(true);
  const handleCloseAddPassengerModal = () => {
    setAddPassengerModal(false);
    getPassengers();
  };

  const handleOpenUpdatePassengerModal = (row) => {
    setCustomerId(row?._id);
    setUpdatePassengerModal(true);
  };
  const handleCloseUpdatePassengerModal = () => {
    setUpdatePassengerModal(false);
    getPassengers();
  };

  const handleOpenDeletePassengerModal = (row) => {
    setCustomerId(row?._id);
    setdeletePassengerModal(true);
  };
  const handleCloseDeleteServiceModal = () => {
    setdeletePassengerModal(false);
    getPassengers();
  };

  const handleHistoryClick = (row) => {
    navigate("/passengerhistory", { state: { passengerdata: row } });
  };

  // Get Passenger list
  const getPassengers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    passengerApi
      .getPassengersList({ page, limit: pageSize, search: "" })
      .then(onSuccess, onFailure);
  }, [page, pageSize, demoaccount_id, dispatch]);

  const getallpassengers = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
    };
    const params = { page: 1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    passengerApi.getPassengersList(params).then(onSuccess, onFailure);
  }, [demoaccount_id, dispatch]);

  useEffect(() => {
    getPassengers();
    getallpassengers();
  }, [getPassengers, getallpassengers]);

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const fullName = `${data?.firstName || ""}`.toLowerCase();
    const mobile = `${data?.countryCode || ""} ${data?.mobileNumber || ""}`.toLowerCase();
    return (
      fullName.includes(searchLower) ||
      data?.email?.toLowerCase().includes(searchLower) ||
      mobile.includes(searchLower) ||
      (data?.corporate_user_id ? "yes" : "no").includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    firstName: data?.firstName,
    email: data?.email,
    mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
    rating: data?.rating,
    corporate: data?.corporate_user_id ? "YES" : "NO",
    row: data,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ["createdAt"], ["asc"]),
    (data, index) => ({
      sno: index + 1,
      firstName: data?.firstName,
      email: data?.email,
      mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
      rating: data?.rating,
      corporate: data?.corporate_user_id ? "YES" : "NO",
    })
  );

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "First Name": row.firstName,
    Email: row.email,
    Mobile: row.mobile,
    Rating: row.rating,
    Corporate: row.corporate,
  }));

  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "First Name": row.firstName,
    Email: row.email,
    Mobile: row.mobile,
    Rating: row.rating,
    Corporate: row.corporate,
  }));

  // Export handlers
  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All PassengerList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const header = ["S.NO", "First Name", "Email", "Mobile", "Rating", "Corporate"].join("\t");
    const rows = dataRows
      .map((r) => [r.sno, r.firstName, r.email, r.mobile, r.rating, r.corporate].join("\t"))
      .join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Passengers");
    XLSX.writeFile(workbook, "PassengerList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "PassengerList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [r.sno, r.firstName, r.email, r.mobile, r.rating, r.corporate]);
    doc.autoTable({
      head: [["S.NO", "First Name", "Email", "Mobile", "Rating", "Corporate"]],
      body: tableData,
    });
    doc.save("PassengerList.pdf");
  };

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Passengers</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Passengers</span>
        </Typography>
      </Box>

      {/* Action Row */}
      <Box className={classes.actionRow}>
        {/* Search */}
        <Box className={classes.searchWrapper}>
          <SearchOutlined className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search passengers..."
            className={classes.searchInput}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
        </Box>

        {/* Right Actions */}
        <Box className={classes.rightActions}>
          {/* Export Group */}
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>Copy</Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>Excel</Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>CSV</Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>PDF</Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>All</Button>
          </Box>

          {/* Add Passenger Button */}
          <Button
            variant="contained"
            className={classes.addButton}
            onClick={handleOpenAddPassengerModal}
            startIcon={<PersonAddAltOutlined />}
          >
            Add Passenger
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>First Name</TableCell>
              <TableCell className={classes.tableHeaderCell}>Email</TableCell>
              <TableCell className={classes.tableHeaderCell}>Mobile</TableCell>
              <TableCell className={classes.tableHeaderCell}>Rating</TableCell>
              <TableCell className={classes.tableHeaderCell}>Corporate</TableCell>
              <TableCell className={classes.tableHeaderCell} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.firstName}
                </TableCell>
                <TableCell className={classes.tableCell}>{rowItem.email}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.mobile}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.rating}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.corporate}</TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <Box
                    component="span"
                    className={classes.historyButton}
                    onClick={() => handleHistoryClick(rowItem.row)}
                  >
                    <History fontSize="small" />
                    History
                  </Box>
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleOpenUpdatePassengerModal(rowItem.row)}
                  >
                    <EditOutlined fontSize="small" />
                    Edit
                  </Box>
                  <Box
                    component="span"
                    className={classes.actionDeleteButton}
                    onClick={() => handleOpenDeletePassengerModal(rowItem.row)}
                  >
                    <DeleteOutline fontSize="small" />
                    Delete
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No passengers found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <PassengerAddModal
        openDialog={addPassenderModal}
        handleClose={handleCloseAddPassengerModal}
      />
      <PassengerUpdateModal
        openDialog={updatePassenderModal}
        id={customerId}
        handleClose={handleCloseUpdatePassengerModal}
      />
      <PassengerDeleteDialog
        openDialog={deletePassengerModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Passenger;
